import {
  Component,
  EventEmitter,
  Input,
  Output,
  OnInit,
  OnDestroy
} from "@angular/core";
import moment from "moment";
import { Moment } from "moment";
import { FormControl, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatIconButton } from "@angular/material/button";
import { MatIcon } from "@angular/material/icon";
import { MatFormField, MatSuffix } from "@angular/material/form-field";
import { MatInput } from "@angular/material/input";
import {
  MatDatepickerInput,
  MatDatepickerToggle,
  MatDatepicker
} from "@angular/material/datepicker";
import { Subscription } from "rxjs";

@Component({
  selector: "app-date-navigator",
  templateUrl: "./date-navigator.component.html",
  styleUrls: ["./date-navigator.component.scss"],
  standalone: true,
  imports: [
    MatIconButton,
    MatIcon,
    MatFormField,
    MatInput,
    FormsModule,
    MatDatepickerInput,
    ReactiveFormsModule,
    MatDatepickerToggle,
    MatSuffix,
    MatDatepicker
  ]
})
export class DateNavigatorComponent implements OnInit {
  date = new FormControl<Date | null>(null);
  @Output() dateChange = new EventEmitter<Moment>();

  private _selectedDate: Moment = moment();

  ngOnInit() {
    // Initialize the form control with the selected date
    this.date.setValue(this._selectedDate.toDate());
  }

  public get selectedDate(): Moment {
    return this._selectedDate;
  }

  @Input()
  public set selectedDate(value: Moment) {
    if (value && moment.isMoment(value)) {
      this._selectedDate = value;
      this.date.setValue(value.toDate());
    }
  }

  nextDay() {
    this.selectDate(moment(this.selectedDate).add(1, "days"));
  }

  previousDay() {
    this.selectDate(moment(this.selectedDate).add(-1, "days"));
  }
  selectDate(date: Date | Moment) {
    const momentDate = moment.isMoment(date) ? date : moment(date);
    this._selectedDate = momentDate;
    this.date.setValue(momentDate.toDate());
    this.dateChange.emit(momentDate);
  }
}
